import React from 'react'
import {Helmet} from 'react-helmet'
import PropTypes from 'prop-types'

import {Heading, Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * FaqList is a React functional component that renders a list of frequently asked questions (FAQs)
 * for a specific product category.
 *
 * @returns {JSX.Element|null} Returns a JSX element containing the FAQ list if there is at least one question-answer pair; otherwise, returns null.
 */
const FaqList = ({faqData = []}) => {
    if (faqData.length === 0) {
        return null
    }

    const structuredData = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqData.map((item) => {
            return {
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: item.answer
                }
            }
        })
    })

    return (
        <>
            <Helmet>
                <script type="application/ld+json">{structuredData}</script>
            </Helmet>

            {/* FAQ Questions / Answers */}
            <Box textAlign="center">
                {faqData.map((item, index) => (
                    <Box key={index} mb={[34, null, 10]}>
                        <Heading as="h3" mb={8}>
                            <Text as="span" textStyle="bodyBase1">
                                {item.question}
                            </Text>
                        </Heading>

                        <Text textStyle="bodyBase2" color="darkGray">
                            {item.answer}
                        </Text>
                    </Box>
                ))}
            </Box>
        </>
    )
}

FaqList.propTypes = {
    faqData: PropTypes.arrayOf(
        PropTypes.shape({
            question: PropTypes.string,
            answer: PropTypes.string
        })
    )
}

export default FaqList
